/**
 * General utilities.
 */

var Store = require('./kvstore.js');
var _ = require('underscore');
var $ = require('jquery');
var pubsub = require('events/pubsub');
var trimHtml = require('trim-html');
const Vue = require('vue');
const moment = require('moment');
const logger = require('utilities/logger');

let modalRefocusTarget = null;

var utils = (module.exports = {
	findPosY: function (obj) {
		var curtop = 0;

		if (obj.offsetParent) {
			while (true) {
				curtop += obj.offsetTop;

				if (!obj.offsetParent) {
					break;
				}

				obj = obj.offsetParent;
			}
		} else if (obj.y) {
			curtop += obj.y;
		}

		return curtop;
	},

	/**
	 * Initializes modal event handlers
	 */
	initModals: function () {
		// Move logic to modal.vue when all modals are migrated to it
		$(document)
			.on('keydown', function (ev) {
				// on escape, close the modal
				if (ev.key === 'Escape') {
					ev.preventDefault();
					utils.closeModals();
				}

				/* Remove this */
				if (ev.key === 'Enter') {
					$('.modal.modal--active .enter-action').each(function () {
						this.click();
					});
				}
			})
			.on('click', function (ev) {
				var $target = $(ev.target);
				// if user clicked an element with data-modal and it has a value, then open that modal
				if ($target.is('*[data-modal]') && $target.attr('data-modal')) {
					utils.openModal($target.attr('data-modal'));

					// if user clicked an element nested inside an element with a data-modal attribute see if it has a value...
				} else if ($target.parents('*[data-modal]')?.size?.() > 0) {
					var $mparent = $target.parents('*[data-modal]');

					// if the data-modal wasn't just a blank attribute, open it
					if ($mparent.attr('data-modal')) {
						utils.openModal($mparent.attr('data-modal'));
					}
				}
			})
			.on('click touchend', function (ev) {
				var $target = $(ev.target);

				// if user clicked an element with data-modal-close attribute, close
				if ($target.is('*[data-modal-close]')) {
					if ($('.modal.modal--active.modal-no-auto-close').size() === 0) {
						utils.closeModals();
					}
					// if user clicked an element nested inside an element with a data-modal-close attribute, close
				} else if ($target.parents('*[data-modal-close]')?.size?.() > 0) {
					if ($('.modal.modal--active.modal-no-auto-close').size() === 0) {
						utils.closeModals();
					}

					// if user clicks .modal-window (our backdrop) then close
				} else if ($target.is('.modal-window, .top-shade')) {
					if ($('.modal.modal--active.modal-no-auto-close').size() === 0) {
						utils.closeModals();
					}
				}
			});
	},

	/**
	 * Closes all modals in the current context, if passed an element or query then
	 * only close that modal
	 * @param {Object} elementOrId   The element or query string (e.g. '#some-id') of the modal.
	 */
	closeModals: function (elementOrId) {
		let $el = elementOrId || $('.modal.modal--active');
		let shouldRefocus = false;

		$el = $($el);

		$el.each(function () {
			if (this.classList.contains('modal--active')) {
				shouldRefocus = true;
				this.classList.remove('modal--active');
				pubsub.publish('modal-closed', this.id || this);
			}
		});

		if ($('.modal.modal--active').size() === 0) {
			document.documentElement.classList.remove('modal-open');
		}

		if (shouldRefocus) {
			const { offsetHeight = 0, offsetWidth = 0 } = modalRefocusTarget || {};
			if (offsetHeight === 0 || offsetWidth === 0) {
				modalRefocusTarget = document.body;
			}
			Vue.nextTick(() => {
				modalRefocusTarget.focus();
			});
		}

		return this;
	},

	/**
	 * Opens a modal for the specified HTML element id.
	 * @param {Object} elementOrId   The element or query string (e.g. '#some-id') of the modal.
	 * @param {Object} options       an (optional) object meant to pass modal-specific options to modal components
	 */
	openModal: function (elementOrId, options = {}, override = true) {
		const hasActiveModals = document.querySelectorAll('.modal--active').length > 0;
		const modal = $(elementOrId)[0];

		options = options || {};

		if (!modal.classList.contains('modal--active') && (override || !hasActiveModals)) {
			if (!options.keepOthers) {
				utils.closeModals();
			}

			if (modal) {
				Vue.nextTick(() => {
					if (!hasActiveModals) {
						modalRefocusTarget = document.activeElement;
					}
					modal.focus();
				});
				modal.classList.add('modal--active');
				pubsub.publish('modal-opened', modal.id, options);
			}
		}

		document.documentElement.classList.add('modal-open');
	},

	/**
	 * Returns the month/day/year string in the form: <MonthName> <DayOfMonth>, <YearName>
	 * E.g., 'March 14, 2015' (will vary on language and locale)
	 * @param unixTimestamp Unix timestamp.
	 * @param locale (optional) The locale. If not provided, defaults to user locale (falling back on en-US)
	 */
	getSimpleDateString: function (unixTimestamp, locale) {
		if (!unixTimestamp) {
			return unixTimestamp;
		}

		var date = new Date((unixTimestamp || Date.now() / 1000) * 1000);
		return date.toLocaleDateString(locale || utils.getUserLocale(), { year: 'numeric', month: 'long', day: 'numeric' });
	},

	/**
	 * Returns the date "mon d" string e.g., 'Mar 14' (will vary on language and locale)
	 * @param unixTimestamp (optional) Unix timestamp. Defaults to now.
	 * @param locale (optional) The locale. If not provided, defaults to user locale (falling back on en-US)
	 */
	getShortDateString: function (unixTimestamp, locale) {
		var date = new Date((unixTimestamp || Date.now() / 1000) * 1000);
		return date.toLocaleDateString(locale || utils.getUserLocale(), { month: 'short', day: 'numeric' });
	},

	/**
	 * Returns the HH:MM AM/PM <timezone> string for the given unix timestamp
	 * E.g., '3:05 PM EST' (will vary on language and locale)
	 * @param unixTimestamp (optional) Unix timestamp. Defaults to now.
	 * @param locale (optional) The locale. If not provided, defaults to user locale (falling back on en-US)
	 */
	getSimpleTimeStringTZ: function (unixTimestamp, locale) {
		// d.toLocaleTimeString('en-US', {hour:'2-digit', minute:'2-digit'});
		var date = new Date((unixTimestamp || Date.now() / 1000) * 1000);
		return date.toLocaleTimeString(locale || utils.getUserLocale(), { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' });
	},

	/**
	 * Returns the HH:MM AM/PM <timezone> string for the given unix timestamp
	 * E.g., '3:05 PM' (will vary on language and locale)
	 * @param unixTimestamp (optional) Unix timestamp. Defaults to now.
	 * @param locale (optional) The locale. If not provided, defaults to user locale (falling back on en-US)
	 */
	getSimpleTimeString: function (unixTimestamp, locale) {
		// d.toLocaleTimeString('en-US', {hour:'2-digit', minute:'2-digit'});
		var date = new Date((unixTimestamp || Date.now() / 1000) * 1000);
		return date.toLocaleTimeString(locale || utils.getUserLocale(), { hour: '2-digit', minute: '2-digit' });
	},

	/**
	 * Returns a string stating "n units ago" for a unit that fits the amount of time
	 * E.g., '22 minutes ago' '1 day ago' '4 hours ago'
	 * @param unixTimestamp (required) Unix timestamp.
	 */
	getElapsedTimeString: function (unixTimestamp, locale) {
		var AGO_INCREMENTS = [
			{ div: 1, singular: 'second', plural: 'seconds' },
			{ div: 60, singular: 'minute', plural: 'minutes' },
			{ div: 3600, singular: 'hour', plural: 'hours' },
			{ div: 60 * 60 * 24, singular: 'day', plural: 'days' }
		];

		var roundTenth = function (n) {
			return Math.round(n * 10) / 10;
		};

		var now = new Date().getTime() / 1000;
		var diff = now - unixTimestamp;
		var inc, nextInc, n;
		for (var i = 0; i < AGO_INCREMENTS.length; i++) {
			inc = AGO_INCREMENTS[i];
			nextInc = AGO_INCREMENTS[i + 1];
			n = diff / inc.div;
			if (!nextInc || roundTenth(diff / nextInc.div) < 1) {
				break;
			}
		}
		n = Math.round(n);
		return '' + n + ' ' + (n > 1 ? inc.plural : inc.singular) + ' ago';
	},
	/**
	 * Returns a comma-separated string representation of an array of strings.
	 * The strings are prefixed by a space.
	 * @param array Must be an array of strings.
	 * @returns {string}    Comma-separated string representation of
	 * specified array or undefined if there is no array.
	 */
	prettyfyArrayAsCommaSepString: function prettyfyArrayAsCommaSepString(array) {
		if (array) {
			// assume array
			var s = JSON.stringify(array);
			s = s.substring(1, s.length - 1);
			return s.replace(/,/g, ', ').replace(/"/g, '');
		}
		return undefined; // strict
	},

	/**
	 * converts the given dashed string to camelCase (e.g. convert from some-value to someValue)
	 */
	camelCase: function (s) {
		var parts = s.split('-');

		var leading = '';

		// leading - becomes 'dash'
		if (parts[0] === '') {
			parts[0] = 'dash';
		}

		var parts2 = [];
		for (var i = 0; i < parts.length; i++) {
			if (i === 0) {
				parts2.push(parts[i]);
			} else {
				parts2.push(parts[i].charAt(0).toUpperCase());
				parts2.push(parts[i].substring(1));
			}
		}
		return leading + parts2.join('');
	},

	/**
	 * Iterates over the values in the object and creates an array of keys sorted by
	 * the property given. e.g. given an object of question sets where the keys are
	 * qsid, the call `orderedIdsByProperty(questionSets, 'title')` returns an Array
	 * of ids sorted by title.
	 * @param  {object} obj the object to be sorted
	 * @param  {string} prop The property to sort
	 * @return {Array}  an array of the keys of the original obj
	 */
	orderedIdsByProperty: function (obj, prop) {
		var tuples = [];
		_.each(obj, function (v, k) {
			tuples.push([k, v]);
		});
		tuples.sort(function (a, b) {
			if (a[1][prop] > b[1][prop]) {
				return 1;
			} else if (a[1][prop] < b[1][prop]) {
				return -1;
			} else {
				return 0;
			}
		});

		return _.map(tuples, function (t) {
			return t[0];
		});
	},

	/**
	 * Escapes HTML special characters so that it may be safely used in Vue's {{{}}} binding
	 * even if we are uncertain of the contents
	 * @param  {string} s string to be escaped
	 * @return {string}   an escaped string
	 */
	escapeHtml: function (s) {
		var n = document.createElement('div');
		n.appendChild(document.createTextNode(s));
		return n.innerHTML;
	},

	/**
	 * Joins 2 URIs, assumes the second one starts with './' or '../', assumes no query string or fragment
	 * @param  {string} uri1 an absolute URI
	 * @param  {string} uri2 a relative URI
	 * @return {string}      the new URI after joining the 2 above
	 */
	joinUri: function (uri1, uri2) {
		if (!uri2) {
			return uri1;
		}

		var uriParts = uri1.split(/\//);
		var newUriParts = uri2.split(/\//);

		var justPopped = false;
		_.each(newUriParts, function (p) {
			switch (p) {
				case '.':
					uriParts[uriParts.length - 1] = '';
					justPopped = true;
					break;
				case '..':
					uriParts.pop();
					justPopped = true;
					break;
				default:
					if (justPopped) {
						uriParts[uriParts.length - 1] = p;
					} else {
						uriParts.push(p);
					}
					justPopped = false;
					break;
			}
		});
		return uriParts.join('/');
	},
	/**
	 * This function analyzes up page.js' context and returns an object that provides easier access to
	 * query parameters.
	 * @param  {object} page.js context
	 * @return {object} parsed path with properties "uri", "fragment", "query" and method "getQueryParam"
	 */
	parsePath: function (ctx) {
		var parseResult = ctx.canonicalPath.match(/^(.*?)(\?(.*?))?(#(.*))?$/);
		var parsedPath = {
			uri: parseResult[1],
			fragment: parseResult[5],
			query: {},
			getQueryParam: function (k) {
				if (this.query[k]) {
					return this.query[k][0];
				} else {
					return undefined;
				}
			}
		};

		var q = parsedPath.query;
		if (ctx.querystring) {
			let parsed = parseResult[3] || '';
			_.each(parsed.split('&'), function (kv) {
				var parts = kv.split('=');
				var k = decodeURIComponent(parts.shift());
				var v = decodeURIComponent(parts.join('='));
				if (!q[k]) {
					q[k] = [];
				}
				q[k].push(v);
			});
		}

		return parsedPath;
	},

	/**
	 * Splits School ID name combo (used as ID in <select>) or returns null
	 * @param  {string} schoolIdName A string as "ID:The school name"
	 * @return {array}              null or ["whole string", "ID", "The school name"]
	 */
	splitSchoolIdName: function (schoolIdName) {
		return (schoolIdName || '-1').match(/^(.+?):(.+)$/);
	},

	/**
	 * Creates strings usable as text labels for students in the array (these are presumed to be
	 * objects coming from Server.getClassRoster or to have uid, username, firstName and lastName properties).
	 * If all the students have different first names, then the labels will simply be their first
	 * names. If 1 or more students has the same first name, then the following steps will be taken
	 * until the labels are unique:
	 * 1. Add the last initial
	 * 2. Add letters from the last name one at a time (up to first 3)
	 * 3. Try the whole first and last name
	 * 4. (if their names are exactly the same) make the label the first name with the student's username in parentheses
	 * @param  {array} students an array of student objects
	 * @return {object} a hash table where value[uid] == 'label-for-student'
	 */
	unambiguousStudentLabels: function (students) {
		/**
		 * Makes student labels, including data about the student according to params
		 *
		 * @param  {Array} students            an array of student objects
		 * @param  {Number} lastNameLetters    how many letters from last name to use (-1 for whole last name)
		 * @param  {Boolean} addUserName       Should an index based on uid be added?
		 * @param  {Boolean} keepCase          if false all student labels will be lowercased
		 *                                     (so we can make sure they're unique), if true
		 *                                     case is left alone
		 *
		 * @return {Object}                    The keys are the label and the values are lists of students with that label
		 */
		var makeStudentLabels = function (studentList, lastNameLetters, addUserName, keepCase) {
			var byKey = {};

			// orderingByKey is used to be able to add a unique number after each students name
			// we were using username, but since that's crazy long (technical term) we now
			// put the distinct uid's into an array, sort the array and use the student uid's
			// index in this array (+1 so we're not 0 based) for that student's number
			var orderingByKey = [];
			if (addUserName) {
				_.each(studentList, function (s) {
					orderingByKey.push(s.uid);
				});
				orderingByKey.sort();
			}

			_.each(studentList, function (s) {
				var k = s.firstName,
					lastName = s.lastName || '';

				if (lastNameLetters === -1 || lastNameLetters === lastName.length) {
					k += ' ';
					k += lastName;
				} else if (lastNameLetters) {
					k += ' ';
					k += lastName.substring(0, lastNameLetters);
					k += '.';
				}

				if (addUserName) {
					k += ' (';
					k += _.indexOf(orderingByKey, s.uid) + 1;
					k += ')';
				}

				if (!keepCase) {
					k = k.toLowerCase();
				}

				if (!byKey[k]) {
					byKey[k] = [];
				}
				byKey[k].push(s);
			});
			return byKey;
		};

		var finalKeys = {};

		// break the students into lists by first name (case insensitive)
		var studentsByFirstName = _.groupBy(students, function (s) {
			return (s.firstName || '').toLowerCase();
		});

		_.each(studentsByFirstName, function (studentsWithThisName, firstName) {
			if (studentsWithThisName.length === 1) {
				// use original firstName property, not the firstName var because the latter
				// has been lowercased
				finalKeys[studentsWithThisName[0].uid] = studentsWithThisName[0].firstName;
			} else {
				var shortestLastNameLength = 1000;
				_.each(studentsWithThisName, function (s) {
					var lastName = s.lastName || '';

					if (lastName.length < shortestLastNameLength) {
						shortestLastNameLength = lastName.length;
					}
				});

				var labelParamTryList = [[null, 1, false, false]]; // 1 last initial

				if (shortestLastNameLength > 2) {
					labelParamTryList.push([null, 2, false, false]); // 2 last initials
				}

				if (shortestLastNameLength > 3) {
					labelParamTryList.push([null, 3, false, false]); // 3 last initials
				}

				labelParamTryList.push([null, -1, false, false]); // whole last name
				labelParamTryList.push([null, -1, true, false]); // whole last name and username in parentheses

				do {
					var params = labelParamTryList.shift();
					params[0] = studentsWithThisName;

					var studentsByLabel = makeStudentLabels.apply(null, params);

					// we got good labels if the number of unique labels matches the number of students
					if (_.keys(studentsByLabel).length === studentsWithThisName.length) {
						params[3] = true; // remake the keys, but keep case this time
						studentsByLabel = makeStudentLabels.apply(null, params);
						_.each(studentsByLabel, function (student, label) {
							finalKeys[student[0].uid] = label;
						});
						break;
					}
				} while (labelParamTryList);
			}
		});

		return finalKeys;
	},

	/**
	 * IE9 & 10 define properties differently from other browsers. This function allows
	 * us to neatly use one way (actually it resembles the IE way of
	 * @param  {object} obj The object that will have the getter/setter
	 * @param  {string} name The name of the property
	 * @param  {[type]} getterSetter an object with a get property and a set property (both are functions, both are optional)
	 */
	defineProperty: function (obj, name, getterSetter) {
		if (Object.defineProperty) {
			Object.defineProperty(obj, name, getterSetter);
		} else {
			if (getterSetter.get) {
				obj.__defineGetter__(name, getterSetter.get);
			}
			if (getterSetter.set) {
				obj.__defineSetter__(name, getterSetter.set);
			}
		}
	},

	/**
	 * Gets the current user locale (e.g. en-US, en-GB, pt-BR) from browser settings, falling back on en-US if it can't detect one
	 * @returns {string} user locale (e.g. "en-US")
	 */
	getUserLocale: function () {
		if (!window || !window.navigator) {
			return 'en-US';
		} else {
			return window.navigator.language || window.navigator.browserLanguage || 'en-US';
		}
	},
	instant400IfMissing: function (required, params, cb) {
		var missing = [];
		_.each(required, function (p) {
			if (!params[p]) {
				missing.push(p);
			}
		});

		if (missing.length > 0) {
			setTimeout(function () {
				logger.info('emulating status 400 due to missing param(s)', missing);
				cb(new Error('Bad Request'), {
					ok: false,
					status: 400,
					serverError: false,
					clientError: true,
					statusText: 'Bad Request'
				});
			}, 1);
		}

		return missing.length > 0;
	},
	pagingInfo: function (currentOffset, total, pageSize) {
		var ret = {
			pagesJumpFirst: null,
			pagesJumpLast: null,
			pages: []
		};
		var currentPageIndex = 0;
		var lastF = 0;
		for (var f = 0, i = 0; f < total; f += pageSize, i++) {
			if (currentOffset >= f && currentOffset < f + pageSize) {
				currentPageIndex = i;
			}
			ret.pages.push({ f: f, number: '' + (i + 1) });
			lastF = f;
		}

		if (currentPageIndex < 4) {
			ret.pages = ret.pages.slice(0, 10);
			ret.pagesJumpFirst = null;
		} else {
			ret.pagesJumpFirst = { f: 0 };
			ret.pages = ret.pages.slice(currentPageIndex - 4, currentPageIndex + 6);
		}

		if (ret.pages.length && lastF !== ret.pages[ret.pages.length - 1].f) {
			ret.pagesJumpLast = { f: lastF };
		} else {
			ret.pagesJumpLast = null;
		}

		return ret;
	},
	// Sort array of objects by specified string property
	sortObjects: function (objects, property) {
		if (objects && _.isArray(objects) && objects.length > 1) {
			return objects
				.map(function (obj, i) {
					var item = { i: i },
						val = obj[property];
					item[property] = typeof val === 'string' ? val.toLowerCase() : val;
					return item;
				})
				.sort(function (a, b) {
					return +(a[property] > b[property]) || +(a[property] === b[property]) - 1;
				})
				.map(function (item) {
					return objects[item.i];
				});
		} else {
			return objects;
		}
	},

	/**
	 * Returns true if a version is part of the "p" passed, false if it contains
	 * only the UUID of the product.
	 *
	 * @param  {String} p The product ID (with or without a version at the end)
	 * @return {Boolean}   [description]
	 */
	productIdHasVersion: function (p) {
		return this.regexp.productIdWithVersion.exec(p) !== null;
	},

	/**
	 * Given a string of product ID containing a version and a UUID
	 * this function will return an object of {uuid:'...', 'version':Number}
	 * if the string is invalid then {uuid:null, version:null} will be returned
	 * @param  {String} p The product ID + version
	 * @return {Object}   an object with a uuid(String) and version(Number) property
	 */
	parseProductUUIDAndVersion: function (p) {
		var match = this.regexp.productIdWithVersion.exec(p);
		if (!this.productIdHasVersion(p)) {
			return { uuid: p, version: null };
		} else if (match === null) {
			return { uuid: null, version: null };
		} else {
			return {
				uuid: match[1],
				version: parseInt(match[2])
			};
		}
	},

	/**
	 * Given a UUID and version, build the product/version string.
	 *
	 * @param  {String} uuid            The product UUID
	 * @param  {String|Number} version  The version (Number or String both OK)
	 * @return {String}                 a valid UUID + version
	 */
	buildProductUUIDAndVersion: function (uuid, version) {
		version = '' + version;
		while (version.length < 4) {
			version = '0' + version;
		}
		var pv = uuid + '_' + version;

		if (this.regexp.productIdWithVersion.exec(pv) !== null) {
			return pv;
		} else {
			return null;
		}
	},

	/**
	 * Given a UUID with no version, append the latest known version and return
	 * a UUID+version (or null if unknown)
	 * @param  {String} p UUID
	 * @return {String}   UUID + version if latest known, null if not known
	 */
	getProductLatestVersionedId: function (p) {
		var pv = utils.parseProductUUIDAndVersion(p);
		if (pv.version) {
			return pv.version;
		}

		var vr = Store.get('productVersionRegistry') || {};

		return vr[p] || null;
	},

	/**
	 * Given results from discovery or a single product, update the latest known
	 * version for use by getProductLatestVersionedId()
	 *
	 * @param  {Object|Array} hits An array of hits from discovery or a single product
	 */
	updateLatestProductVersions: function (hits) {
		// if hits is just one product, then wrap it in an array
		if (hits.p || hits.id) {
			hits = [hits];
		}

		var vr = Store.get('productVersionRegistry');
		if (!vr) {
			vr = {};
			Store.set('productVersionRegistry', vr);
		}

		_.each(hits, function (hit) {
			var idWithVersion = hit.p || hit.id;
			var pv = utils.parseProductUUIDAndVersion(idWithVersion);
			if (pv.uuid && pv.version) {
				vr[pv.uuid] = idWithVersion;
			}
		});
	},

	/**
	 * Returns a deep copy of the object passed
	 * @param  {Object} o object to clone
	 * @return {Object}   the clone
	 */
	cloneDeep: function (o) {
		if (!o) {
			return o;
		}
		return JSON.parse(JSON.stringify(o));
	},

	/**
	 * Returns localStorage if it is currently available, a JS object if not
	 * @return {Object}   localStorage or a plain object
	 */
	getLocalStorageOrObject: function (o) {
		var TEST_KEY = 'readworksLocalStorageTestKey';
		var store;
		try {
			store = window.localStorage;
			// this may throw an error right here
			store.setItem(TEST_KEY, 'abc');

			// or the localStorage may also silently fail during set, but always
			// return undefined
			if (store.getItem(TEST_KEY) !== 'abc') {
				throw new Error();
			} else {
				// localStorage works fine, clean up our test key
				store.removeItem(TEST_KEY);
			}
		} catch (e) {
			// falling back on a memory store
			store = {};
		}

		return store;
	},

	// Regular expressions
	regexp: {
		email:
			/^(([^<>\(\)\[\]\\.,;:\s@"]+(\.[^<>\(\)\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		hasspecialchar: /[- ,_#@!$%^&*~\.;:"'\?]/,
		productIdWithVersion: /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})_(\d{4})$/,
		zipcode: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
		studentPassword: /^\S{4,}$/,
		teacherPassword: /^(?=.*[a-zA-Z])(?=.*[\d`~!@#$%^&*\(\)\-_=+\[\{\]\}\|;:'",<.>\/?]\S).{8,}$/
	},

	createPreview: function (article, minWords = 0, maxWords = 50, wordPercentage = 0.25) {
		let articleWordCount = article.wordCount;
		let content = article.content;
		let elementsToIgnore = ['figure', 'img', 'table', '#text'];
		let wordCount = 0;
		let characterCount = 0;
		let contentIsSmallerThanCount = true;

		//25% of content to a max of 50
		let targetWordCount = Math.max(Math.min(Math.floor(wordPercentage * articleWordCount), maxWords), minWords);

		$(content).each((idx, el) => {
			let nodeType = (el.nodeName || '').toLowerCase();
			let text = el.textContent;
			if (elementsToIgnore.indexOf(nodeType) === -1 || (nodeType === '#text' && !/^\n+$/.test(text))) {
				let wordList = text.split(' ');
				// Element that counts towards targetWordCount,
				// but doesn't go over it.
				if (wordList.length < targetWordCount - wordCount) {
					wordCount += wordList.length;
					characterCount += text.length;
				}
				// This element puts us over the limit
				// So find where in the element we need to cut
				else {
					// Count the words up to the targetWordCount
					let wordsToCount = wordList.slice(0, targetWordCount - wordCount);
					wordCount += wordsToCount.length;
					characterCount += wordsToCount.join(' ').length;
					contentIsSmallerThanCount = false;
					return false;
				}
			} else {
				// Ignored element, but we need to take it's text content into account.
				characterCount += text.length;
			}
			return true;
		});

		// Library to trim HTML without DOM manipulation
		let pageContent = content;

		// For small numbers of words, no need to trim
		if (pageContent && !contentIsSmallerThanCount) {
			let trimmed = trimHtml(content, {
				limit: characterCount
			});
			pageContent = trimmed && trimmed.html ? trimmed.html : pageContent;
		}

		return {
			content: pageContent,
			wordCount
		};
	},

	getWordCount(text) {
		let wordCount = 0;
		let modifiedText = null;
		let words = [];
		if (text && text.length && typeof text === 'string') {
			// Remove leading and trailing whitespace and line breaks
			modifiedText = text.replace(/(?:\r\n|\r|\n|\u21b5)/g, '').trim();

			// Split on whitespace groups
			words = modifiedText.split(/\s+/);

			// Remove empty values
			words = words.filter(w => {
				return w && w.length;
			});

			// Finally count words
			wordCount = words.length;
		}
		return wordCount;
	},

	stripHTMLFromString(html) {
		var doc = new DOMParser().parseFromString(html, 'text/html');
		return doc.body.textContent || '';
	},

	formatTime(seconds) {
		let duration = moment.duration(seconds, 'seconds');
		let minutesFormatted = duration.get('minutes');
		let secondsFormatted = duration.get('seconds');

		if (secondsFormatted === 0) {
			secondsFormatted = '00';
		} else if (secondsFormatted < 10) {
			secondsFormatted = '0' + secondsFormatted;
		}

		return minutesFormatted + ':' + secondsFormatted;
	},

	linebreakStr(text, maxlength = 20, maxlines = 4) {
		let textStr = text;
		if (text.length > maxlength) {
			textStr = '';
			let tokens = text.split(' ');
			let lines = [];
			let line = '';
			if (tokens && tokens.length) {
				tokens.forEach(t => {
					t = t.replace(/[\n\r]/g, '');
					if (line.length < maxlength && line.length + t.length < maxlength) {
						line += t + ' ';
					} else {
						lines.push(line.substr(0, line.length - 1));
						line = t + ' ';
					}
				});
				lines.push(line);
				if (lines.length > maxlines) {
					lines = lines.splice(0, maxlines);
					let lastLine = lines[lines.length - 1];
					lines[lines.length - 1] = lastLine.substr(0, lastLine.length - 4) + '...';
				}
				textStr = lines.join('\n');
			}
		}
		return textStr;
	},
	isFocusable(element) {
		/* Most of this logic originates from the WAI ARIA dialog modal example
		 * https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/dialog.html
		 */
		const { tabIndex, disabled, hidden, localName, href, rel, type } = element;
		if (tabIndex < 0 || disabled || hidden) {
			return false;
		}

		switch (localName) {
			case 'a':
				return !!href && rel !== 'ignore';
			case 'input':
				return type !== 'hidden';
			case 'button':
			case 'select':
			case 'textarea':
				return true;
			default:
				return false;
		}
	},
	getFirstFocusableElement(element) {
		for (let i = 0; i < element.children.length; i++) {
			const target = element.children[i];

			const focusTarget = utils.isFocusable(target) ? target : utils.getFirstFocusableElement(target);

			if (focusTarget) {
				return focusTarget;
			}
		}

		return null;
	},
	getLastFocusableElement(element) {
		for (let i = element.children.length - 1; i >= 0; i--) {
			const target = element.children[i];

			const focusTarget = utils.isFocusable(target) ? target : utils.getLastFocusableElement(target);

			if (focusTarget) {
				return focusTarget;
			}
		}

		return null;
	},
	cleanVocabLinks(articleContent = '') {
		/* Convert vocab word spans to links
			some words are wrapped twice
		*/
		return articleContent
			.replace(/(<span data-vocab-sense-id[^>]*>)(<span data-vocab-sense-id[^>]*>\w+<\/span>)(<\/span>)/g, (block, match1, match2) => {
				return match2;
			})
			.replace(/(<span data-vocab-sense-id)([^>]*>\w+)(<\/span>)/g, (block, match1, match2) => {
				const replacement1 = '<a href="javascript:void(0)" aria-haspopup="dialog" data-vocab-sense-id';
				const replacement3 = '</a>';

				return `${replacement1}${match2}${replacement3}`;
			});
	},
	initTTSVoices() {
		// Clear queue on init
		speechSynthesis.cancel();
		const englishTags = new Set(['en-US', 'en_US']);
		const spanishTags = new Set(['es-MX', 'es-US', 'es', 'es_MX', 'es-ES']);

		const getVoices = systemVoices => {
			const voices = systemVoices.reduce(
				(acc, voice) => {
					if (englishTags.has(voice.lang)) {
						acc.en.set(voice.name, voice);
					} else if (spanishTags.has(voice.lang)) {
						acc.es.set(voice.name, voice);
					}
					return acc;
				},
				{ en: new Map(), es: new Map() }
			);

			const preferredVoiceSequences = {
				en: [
					'Microsoft Aria Online (Natural) - English (United States)',
					'Samantha',
					'Victoria',
					'Google US English',
					'Chrome OS US English 1',
					'Microsoft Zira - English (United States)',
					'Microsoft Zira Desktop - English (United States)',
					'Microsoft Zira Mobile - English (United States)',
					'Microsoft Anna - English (United States)',
					'English United States',
					'English (America)+female',
					'English (America)+Steph',
					'en-US',
					'inglés Estados Unidos'
				],
				es: [
					'Paulina',
					'Android Speech Services by Google es-US-language',
					'Microsoft Paloma Online (Natural) - Spanish (United States)',
					'Google español de Estados Unidos',
					'Shelley (Spanish (Mexico))',
					'Google español'
				]
			};

			const preferredVoices = {};
			for (const lang in preferredVoiceSequences) {
				let found;
				for (const name of preferredVoiceSequences[lang]) {
					found = voices[lang].get(name);

					if (found) {
						break;
					}
				}
				preferredVoices[lang] = found || voices[lang].values()[0];
			}

			return preferredVoices;
		};

		return new Promise(resolve => {
			// Voices are loaded asynchronously
			// Use `speechSynthesis.onvoiceschanged` when Safari 16 is the minimum supported version
			const voiceInterval = setInterval(() => {
				const voices = speechSynthesis.getVoices();
				if (voices.length > 0) {
					resolve(getVoices(voices));
					clearInterval(voiceInterval);
				}
			}, 10);
		});
	},
	isExternalLink(link) {
		const internalHosts = new Set([window.location.hostname, 'www.readworks.org', 'readworks.org']);

		return link.startsWith('http') && !internalHosts.has(new URL(link).hostname);
	},
	closeGCAIframe() {
		window.parent.postMessage(
			{
				type: 'Classroom',
				action: 'closeIframe'
			},
			'*'
		);
	}
});
